import axios from "axios";
import { BASE_URL } from "config/api_collection";
import { ERROR_API_NAME } from "../constants/variables";
import apolloClient from "../graphql";
import { GET_CURRENT_BOOKING_STATE_CHECKIN } from "../graphql/checkinQueries";
import { errorHandingErrorMessage } from "../services/errrorHandling/errorHandling";
import { getHeaderData } from "./crm";
import { getToken } from "helper/token";

const GET_CURRENT_BOOKING_IN_STATE = `${BASE_URL}/api/ibe/booking`;
const GET_GROUP_BOOKING_IN_STATE = `${BASE_URL}/api/ibe/groupBooking/getGroupBookingInState`;
const CANCELLED_BOOKING_IN_STATE = `${BASE_URL}/api/ibe/booking/v2/refunds/info`
const DECRYPT = `${BASE_URL}/api/ibe/booking/retrieve`;

export async function CurrentBookingInState() {
  try {
    const headers = getHeaderData();
    const groupBookingString = sessionStorage.getItem("groupBooking");
    const isGroupBookingRetrieved = groupBookingString === 'true';

    const passnegerKeys = sessionStorage.getItem('passnegerKeys');
    const passnegerKeysArr = passnegerKeys ? JSON.parse(passnegerKeys) : [];

    let response;

    if (isGroupBookingRetrieved) {
      response = await axios.post(GET_GROUP_BOOKING_IN_STATE, passnegerKeysArr, { headers });
    } else {
      response = await axios.get(GET_CURRENT_BOOKING_IN_STATE, { headers });
    }

    return response;

  } catch (error) {
    return errorHandingErrorMessage(ERROR_API_NAME.CURRENT_BOOKING_IN_STATE, error);
  }
}

export async function CancelledBookingInState() {
  try{
    const headers = getHeaderData();
    const response = await axios.get(CANCELLED_BOOKING_IN_STATE, { headers });
    return response;
  }catch(error){
    return errorHandingErrorMessage(ERROR_API_NAME.CANCELLED_BOOKING_IN_STATE, error)
  }
}

export async function CurrentBookingInStateCheckin() {
  const response = await apolloClient
    .query({
      query: GET_CURRENT_BOOKING_STATE_CHECKIN,
      variables: {},
      fetchPolicy: "no-cache"
    })
    .catch((err) => {
      console.error(err);
    });
  return response;
}

export const decryptAndGetCurrentBookingInStateWithRequestId = async (requestObject: object) => {
  try {
    const tokenHeaders = await getToken();
    const headers: any = tokenHeaders;
    const decryptedData = await axios.get(DECRYPT, {
      params: requestObject,
      headers
    });
    return decryptedData;
  } catch (err) {
    return false;
  }
};
